module.exports = __webpack_public_path__ + "img/reddit-square.ee0b659c.svg";